import { render, staticRenderFns } from "./RubikFace.vue?vue&type=template&id=b34c2baa&scoped=true&lang=pug"
import script from "./RubikFace.vue?vue&type=script&lang=js"
export * from "./RubikFace.vue?vue&type=script&lang=js"
import style0 from "./RubikFace.vue?vue&type=style&index=0&id=b34c2baa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34c2baa",
  null
  
)

export default component.exports